import { Tooltip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import { PTypographyLoading } from '@/components/molecules/TypographyLoading/PTypographyLoading';
import createAvatar from '@/utils/createAvatar';
import { TypographyVariant } from './atoms/Typography/types';

interface InlineUserProps extends React.ComponentProps<typeof Avatar> {
  firstName?: string | null;
  lastName?: string | null;
  onClick?: VoidFunction;
  size?: number;
  showNameAsTooltip?: boolean;
  typographyVariant?: TypographyVariant;
  isLoading?: boolean;
}

export default function InlineUser({
  firstName,
  lastName,
  onClick,
  size = 40,
  showNameAsTooltip = false,
  sx,
  typographyVariant = 'body2',
  isLoading = false,
}: InlineUserProps) {
  const fullName = [firstName, lastName].filter(Boolean).join(' ');

  const avatar = createAvatar(firstName, lastName);

  const avatarComponent = (
    <Avatar sx={{ width: size, height: size }} color={avatar?.color}>
      <PTypographyLoading variant={typographyVariant} color="secondary" isLoading={isLoading} loaderWidth={10}>
        {avatar?.name}
      </PTypographyLoading>
    </Avatar>
  );

  return (
    <Stack direction="row" alignItems="center" onClick={onClick} sx={sx}>
      {showNameAsTooltip ? (
        <Tooltip title={fullName} arrow>
          {avatarComponent}
        </Tooltip>
      ) : (
        <>
          {avatarComponent}
          <PTypography variant={typographyVariant} sx={{ pl: 2 }}>
            {fullName}
          </PTypography>
        </>
      )}
    </Stack>
  );
}
